import React, { createContext, useContext, useState, useCallback } from 'react';

interface RefreshContextValue {
  refreshKey: number;
  refresh: () => void;
}

const RefreshContext = createContext<RefreshContextValue>({ refreshKey: 0, refresh: () => {} });

export const RefreshProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey(k => k + 1), []);
  return <RefreshContext.Provider value={{ refreshKey, refresh }}>{children}</RefreshContext.Provider>;
};

export const useRefresh = () => useContext(RefreshContext);
